import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      flat: "",
      rounded: "lg",
      class: "stock-transaction-card"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, { class: "d-flex align-center justify-space-between px-4 py-3" }, {
          default: _withCtx(() => [
            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-h6 font-weight-medium" }, "Stock Transactions", -1)),
            _createVNode(_component_v_btn, {
              color: "primary",
              variant: "tonal",
              rounded: "lg",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($data.dialog = true))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: "plus",
                  class: "mr-2"
                }),
                _cache[11] || (_cache[11] = _createTextVNode("New Transaction ", -1))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_divider),
        _createVNode(_component_v_card_text, { class: "pa-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_data_table, {
              headers: $data.grid.headers,
              items: $data.stockTransactionsPlatformWise,
              "sort-by": [{ key: 'created_at', order: 'desc' }],
              "items-per-page-options": [10, 15, 20, 30, 50, 100, 200],
              "items-per-page": 10,
              density: "comfortable",
              class: "custom-data-table",
              "item-value": "stock_transaction_id"
            }, {
              [`item.stock.name`]: _withCtx(({ item }) => [
                _createVNode(_component_router_link, {
                  target: "_blank",
                  name: "stock-view",
                  to: { path: '/stock/view', query: { id: item.stock.code } }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.stock.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              [`item.amount`]: _withCtx(({ item }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$helper.formatPrice(item.amount)), 1)
              ]),
              [`item.sub_total`]: _withCtx(({ item }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$helper.formatPrice(item.sub_total)), 1)
              ]),
              [`item.created_at`]: _withCtx(({ item }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$helper.formatDate(item.created_at, true)), 1)
              ]),
              _: 2
            }, 1032, ["headers", "items"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: $data.dialog,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($data.dialog) = $event)),
      "max-width": "900px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-h6 font-weight-bold" }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createTextVNode("New Transaction", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { dense: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: $data.editedItem.stock_transaction_id,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.editedItem.stock_transaction_id) = $event)),
                              label: "Transaction ID",
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              modelValue: $data.editedItem.platform_id,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.editedItem.platform_id) = $event)),
                              items: _ctx.$helper.optionArray($setup.platformList, 'platform_id', 'name'),
                              "item-title": "label",
                              "item-value": "code",
                              label: "Platform",
                              variant: "outlined",
                              "hide-details": "",
                              density: "comfortable"
                            }, null, 8, ["modelValue", "items"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              modelValue: $data.editedItem.stock_id,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.editedItem.stock_id) = $event)),
                              items: _ctx.$helper.optionArray(this.stock, 'stock_id', 'name'),
                              "item-title": "label",
                              "item-value": "code",
                              label: "Select Stock",
                              variant: "outlined",
                              "hide-details": "",
                              density: "comfortable"
                            }, null, 8, ["modelValue", "items"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              modelValue: $data.editedItem.action,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.editedItem.action) = $event)),
                              items: _ctx.$optionHelper.stockAction,
                              "item-title": "label",
                              "item-value": "code",
                              label: "Action",
                              variant: "outlined",
                              "hide-details": "",
                              density: "comfortable"
                            }, null, 8, ["modelValue", "items"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: $data.editedItem.qty,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.editedItem.qty) = $event)),
                              label: "Quantity",
                              variant: "outlined"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: $data.editedItem.amount,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($data.editedItem.amount) = $event)),
                              label: "Amount",
                              variant: "outlined"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: $data.editedItem.sub_total,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($data.editedItem.sub_total) = $event)),
                              label: "Sub Total",
                              readonly: "",
                              variant: "outlined"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: $data.editedItem.stock_avg_price,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($data.editedItem.stock_avg_price) = $event)),
                              label: "Stock Avg Price",
                              variant: "outlined"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6",
                          md: "4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: $data.editedItem.created_at,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($data.editedItem.created_at) = $event)),
                              label: "Created At",
                              type: "date",
                              variant: "outlined"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: $options.close
                }, {
                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                    _createTextVNode("Cancel", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "tonal",
                  onClick: $options.save
                }, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createTextVNode("Save", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}